import { AnimatePresence, motion } from "framer-motion";
import Button from "../Button";
import "swiper/css";
import MediaWrap from "../MediaWrap";
import Heading from "../Heading";
import Params from "../Params";

export default function TabsContent({ selected }) {
  return (
    <>
      <div className="ob-tab-content ob-columnar">
        <AnimatePresence>
          <motion.div
            key={selected.id}
            initial={{ opacity: 0, zIndex: 0 }}
            animate={{ opacity: 1, zIndex: 1 }}
            exit={{ opacity: 0, zIndex: 0 }}
            transition={{ duration: 1 }}
            className="ob-columnar"
            role="tabpanel"
          >
            {selected &&
              selected.tabContent.variants.map((variant) => {
                const variantMedia = { ...variant.media };
                const { headingType, title, description, qty, size } = variant;
                const variantHeading = { headingType, title, description };
                const variantParams = { qty, size };

                return (
                  <div key={variant.id} className="ob-variant">
                    <div className="ob-variant-wrap">
                      <MediaWrap params={variantMedia} />

                      <Heading params={variantHeading} />

                      <Params params={variantParams} />

                      <Button params={variant.button} />
                    </div>
                  </div>
                );
              })}
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
}
